// Load libraries used by the Angular app
import './dependencies';

// Load the Angular app's CSS, JS and HTML modules
import '../../src/index.scss';
import '../../.tmp/angular-src-index';
import './template-cache';

// Start the Angular app
import _ from 'lodash';
import angular from 'angular';

// isBrowserSupported is determined/attached to window in index.html file
if (window.isBrowserSupported) {
  document.addEventListener('DOMContentLoaded', () => {
    // when the e2e user is running, we expect that the protractor tests are inserting
    // a module here between bootstrap and appFakes
    const mockUserId = getParameterByName('mockUserId');
    if (mockUserId) {
      import(/* webpackChunkName: "fakes" */ '../../fakes/fakes')
        .then(() => {
          angular.bootstrap(document, [mockUserId === 'e2eUser' ? 'appE2E' : 'appFakes']);
        })
        // eslint-disable-next-line no-console
        .catch((error) => console.error('error dynamically loading fakes', error));
    } else {
      angular.bootstrap(document, ['app']);
    }
  });
}

/**
 * @description Gets the query parameter value
 * @param {String} name - the parameter key
 * @returns {String} the parameter value
 */
function getParameterByName(name) {
  const url = window.location.href;
  const cleansedName = _.replace(name, /[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${cleansedName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(_.replace(results[2], /\+/g, ' '));
}
